import { NgModule } from "@angular/core";
import { NgAfterInitDirective } from "./ng-after-init.directive";
import { DigitOnlyDirective } from "./digit-only.directive";
import { MailToDirective } from "./mail-to.directive";
import { CallToDirective } from "./call-to.directive";
import { ClickStopPropagation } from "./stop-propagation.directive";
import { ACLDirective } from "./acl-directive";
import { WhatsappToDirective } from "./whatsapp-to-directive";
import { WhatsappContentDirective } from "./whatsapp-content-directive";

@NgModule({
  imports: [],
  declarations: [
    NgAfterInitDirective,
    DigitOnlyDirective,
    MailToDirective,
    CallToDirective,
    ACLDirective,
    ClickStopPropagation,
    WhatsappToDirective,
    WhatsappContentDirective,
  ],
  exports: [
    NgAfterInitDirective,
    DigitOnlyDirective,
    MailToDirective,
    ACLDirective,
    CallToDirective,
    ClickStopPropagation,
    WhatsappToDirective,
    WhatsappContentDirective
  ],
})
export class CustomDirectiveModule {}
